import React from 'react'

function NotFound() {
  return (
    <h1>Страница не найдена</h1>
  )
}
export default NotFound;